export class Links{
    static readonly HelpSimulator = 'https://www.alec-grenoble.org/uploads/alec38_calculatrice/#/'
    static readonly ContactAdviser = 'https://www.grenoblealpesmetropole.fr/178-contacter-un-conseiller-energie.htm';
}